module.exports = __webpack_public_path__ + "static/media/hands_22.7d13c3a4.svg";